const isLocalDevelopmentHost = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const environment = {
  production: false,
  // Use the dev-server proxy locally; use the absolute API when this build is
  // served from the deployed Angular development hostname.
  apiBaseUrl: isLocalDevelopmentHost
    ? '/api'
    : 'https://lbc-hub-api-dev.clovercore.co/api',
  enableLogging: true,
  enableCrashReporting: false,
  enableAnalytics: false,
  appName: 'LBCHub (Development)',
  appVersion: '1.0.0',
  cacheExpirationMinutes: 5,
  showDebugBanner: true,
  tokenExpirationBufferMinutes: 5,
};
